import React from 'react';
import './Education.css'; // Import your CSS file for styling
import CustomButton from './Custombtn';

function Education({collegedetails,board,year,grade,activities,imglink}) {
  return (
    <div className="card">
       <div className='imgBx'>
        <img src={imglink} alt='working crt'/>
       </div>
       <div className='content'>
        <h2>
            {collegedetails}
        </h2>
        <p>{board}</p>
        <p>{year}</p>
        <p>Grade:{grade}</p>
        <p>{activities}</p>
        <div className='readmore'>
            <CustomButton btntitle="Read More..." href=""/>
        </div>
       </div>
    </div>
  );
}

export default Education;
